import { useHistory } from "react-router";
import axios from "axios";
import { useState } from "react";

import {
  Container,
  LogoImg,
  InputContainer,
  H1Login,
  ContainerInput,
  InputLogin,
  ContainerButtonLogin,
  ButtonLogin,
  ContainerButtonWeb,
  ImgWeb,
  SmallFooter,
} from "./style";

const Register = () => {
  
  const history = useHistory();

  const [name, setName] = useState("");
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("")

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  function register() {

    const data = {
      "admin": false,
      "industria": null,
      "login": email,
      "nome": name,
      "senha": password,
      "supermercado": null,
      "usuario": 0
    }

    console.log(data)

    if(password === confirmPassword) {
      api.post("/api/usuario/cadastrar", data)
      .then(response => console.log(response))

      history.push("/")
    } else {
      setError("As senhas não coincidem")
    }

  }

  return (
    <Container>
      <LogoImg src="./images/logohAsset 3.png" />
      <InputContainer>
        <H1Login>Registro</H1Login>

        <ContainerInput>
          <InputLogin
            type="text"
            name="name"
            placeholder="Nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <InputLogin
            type="email"
            name="email"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <InputLogin 
          type="password" 
          name="password" 
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          />
          <InputLogin
            type="password"
            name="confirmPassword"
            placeholder="Confirmar Senha"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <p>{error}</p>
          <ContainerButtonLogin>
            <ButtonLogin onClick={() => register()}>
              Cadastrar
            </ButtonLogin>
          </ContainerButtonLogin>
        </ContainerInput>
      </InputContainer>
      <ContainerButtonWeb>
        <a href="https://mail.google.com/mail/u/0/#inbox" target="blank">
          <ImgWeb src="./images/button_gmail.svg" />
        </a>
        <a href="https://facebook.com" target="blank">
          <ImgWeb src="./images/button_face.svg" />
        </a>
      </ContainerButtonWeb>
      <SmallFooter>Powered by Mercadata Digital</SmallFooter>
    </Container>
  );
};
export default Register;
